// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.
import { utilityServiceUrl, localEnvironment } from '../../../../libs/menu-shared/src/environments/default-menu.config';

export const environment = {
  production: false,
  ACCOUNT_EXPLORE_DECODER_URL: '/en-ng/buy/decoders',
  ACCOUNT_EXPLORE_URL: '/en-ng/buy/get-dstv/',
  ACCOUNT_LINKING_URL:
    'https://alpha-authentication.dstv.com/registration/link?existing=True&access_token={access_token}&redirect_uri={redirect_url}',
  ACCOUNT_TSANDCS_BANNER: 'https://multichoice.com/multichoice-africa-subscriber-ts-cs-overview-sa.php',
  ACCOUNT_TSANDCS_BANNER_MAH: 'https://www.multichoice.com/multichoice-africa-subscriber-ts-cs-overview.php',
  PRIVACY_EXERCISE_RIGHTS: 'https://www.multichoice.com/exercise-your-rights.php',
  ACTIVATION_LINK_RETRY_INTERVAL: 5000,
  ACTIVATION_LINK_RETRY_LIMIT: 40,
  ACTIVATION_LINK_SHORT_RETRY_LIMIT: 1,
  AKAMAI_AUTH_RETURN_URL: '/auth-redirect.html',
  AKAMAI_BU: 'DStvResSelfService',
  AKAMAI_HOSTED_URL: 'https://v1.api.eu.janrain.com/ad1882fb-e493-4f16-880e-9f9da7bfa1ca',
  AKAMAI_OIDC_CLIENT_ID: '4b5c53f1-aa16-479a-b368-a75641f8d8fd',
  ANALYTICS_STRUCTURE_API_URL: '',
  ANALYTICS_STRUCTURE_USE_API: 'true',
  APP_ROOT_URL: '/{culture}',
  ANYWHERE_STREAMS_PACKAGES: 'PRMOTT,COMPKUOTT,EXTRAKUOTT',
  BASEURL: '{language}/mydstv/',
  BOXOFFICE_URL: '/{culture}/buy/boxoffice',
  BYPASS_INTERNET_ELIGIBILITY: true,
  CACHE_TIMEOUT_ACCOUNT: 60,
  CACHE_TIMEOUT_BUNDLES: 15,
  CACHE_TIMEOUT_CONTENT: 5760,
  CACHE_TIMEOUT_CURRENCY: 30,
  CACHE_TIMEOUT_CUSTOMER: 1440,
  CACHE_TIMEOUT_DASHBOARD: 86400,
  CACHE_TIMEOUT_FIX_ERROR: 1440,
  CACHE_TIMEOUT_INBOX: 1440,
  CACHE_TIMEOUT_LIVE_CHAT: 5,
  CACHE_TIMEOUT_ON_DEMAND_SERVICES: 1440,
  CACHE_TIMEOUT_PAYMENTS: 5,
  CACHE_TIMEOUT_PRODUCTS: 60,
  CACHE_TIMEOUT_PROFILE: 1440,
  CACHE_TIMEOUT_REWARDS: 1440,
  CACHE_TIMEOUT_CAMPAIGN_ANALYTICS: 5760,
  CAPITEC_ELIGIBLE_PACKAGES: 'PRMOTT,COMPKUOTT,ACCESSOTT',
  CONNECT_DSTV_CLIENT_ID: 'da01a4c6-2d5e-4a30-84e0-31c555ed08b0',
  CONNECT_GOTV_CLIENT_ID: 'da01a4c6-2d5e-4a30-84e0-31c555ed08b0',
  CONNECT_PUBLIC_URL: 'https://alpha-ssl.dstv.com/api/auth',
  CONNECT_URL: 'https://alpha-authentication.dstv.com/registration',
  CUSTOMER_CARE_URL: '/{culture}/help/contact-us',
  DEFAULT_AUTH_PROVIDER: 'connect',
  DEFAULT_CACHE_DEBOUNCE: 120,
  DEFAULT_CACHE_TIMEOUT: 1440,
  DEFAULT_COUNTRY: 'za',
  DEFAULT_LANGUAGE: 'en',
  DEFAULT_LOCALE: 'en-za',
  DSTV_REDIRECT_URL_BASE: '/{locale}/mydstv/#/dashboard',
  DSTV_REDIRECT_URL_QUERY_PARAMS: '/#access_token={accessToken}&id_token={idToken}&provider={provider}',
  DSTV_STORE_URL: 'https://getdstv.dstv.co.za',
  DSTV_STREAM: 'https://dstv.stream',
  DSTV_UTILITY_SERVICE: utilityServiceUrl,
  FAQ_LINK: '/en-za/help/faqs',
  FIND_INSTALLER_OR_DEALER_TRANSLATED_URL:
    '/{culture}/adira/encontre-um-instalador-ou-loja',
  FIND_INSTALLER_OR_DEALER_URL: '/{culture}/buy/find-installer-or-dealer',
  FRESHDESK_AUTH: 'qt4kORJLY62PufT8EoMz',
  FRESHDESK_CANCEL_FIBRE_EMAIL_CONFIG_ID: 75000002255,
  FRESHDESK_CANCEL_FIBRE_GROUP_ID: 3043000318076,
  FRESHDESK_CARE_PLAN_CF_CR_QUERY_SOURCE: 'cf_cr_query_source',
  FRESHDESK_CARE_PLAN_CF_CR_QUERY_TYPE: 'cf_cr_query_type',
  FRESHDESK_CARE_PLAN_FIBRE_EMAIL_CONFIG_ID: 75000003445,
  FRESHDESK_CARE_PLAN_FIBRE_GROUP_ID: 3043000321316,
  FRESHDESK_Data_REQUEST_CEO_ID_CF: 'cf_data_subject_right441700',
  FRESHDESK_Data_REQUEST_GROUP_CEO_ID: 3043000311965,
  FRESHDESK_Data_REQUEST_GROUP_POPIA_ID: 3043000319626,
  FRESHDESK_Data_REQUEST_POPIA_ID_CF: 'cf_data_subject_right965178',
  FRESHDESK_RELOCATE_FIBRE_CF_ADDRESS: 'cf_relocation_address',
  FRESHDESK_RELOCATE_FIBRE_EMAIL_CONFIG_ID: 75000003445,
  FRESHDESK_RELOCATE_FIBRE_GROUP_ID: 3043000320522,
  FRESHDESK_URL: 'https://multichoiceeuc.freshdesk.com/api/v2',
  GET_MONTHLY_BUNDLE_RETRY_INTERVAL: 1500,
  GET_MONTHLY_BUNDLE_RETRY_LIMIT: 10,
  GOTV_COUNTRY_CODE_INCLUSION_LIST: 'gh,ke,ke,mw,mz,na,ug,zm',
  GOTV_REDIRECT_URL_BASE: '/gotv/{locale}/mygotv/#/dashboard',
  GOTV_REDIRECT_URL_QUERY_PARAMS: '/#access_token={accessToken}&id_token={idToken}&provider={provider}',
  HAPTIK_BASE_URL: 'https://staging.hellohaptik.com/',
  HAPTIK_PRIVACY_POLICY_URL: 'https://www.multichoice.com/privacy-cookie-notice/',
  HAPTIK_SS_BUSINESS_ID: '2412',
  HAPTIK_SS_CLIENT_ID: 'c5fccab2185cbb829da1ee4692c0e213fd70d751',
  HELP_LINK: '/{culture}/help',
  HOW_TO_PAY_LINK: '/en-mu/pay/how-to-pay',
  INBOX_POLL_TIME_MAX: 12780000,
  INBOX_POLL_TIME_START: 1230000,
  INTERNAL_RETURN_URL: '{origin}/{language}/mydstv',
  LIVE_CHAT_CONFIG: {
    sentMessageTracking: true,
  },
  LIVE_CHAT_HUB: 'chathub',
  LIVE_CHAT_IFRAME: 'https://dso-livechatcloud-dev-websocket.azurewebsites.net',
  LOCALES_BASEURL: '/content/self-service/i18n/locales/',
  LOCALISED_HARDWARE: ['pt-ao', 'pt-mz'],
  LOCALISED_PACKAGES: ['pt-ao', 'pt-mz', 'en-et'],
  MAH_API_ACCOUNT: 'accountmanagement-unifiedapi',
  MAH_API_AMOUNT_TO_PAY: 'atp-unifiedapi',
  MAH_API_BASE_URL: `${utilityServiceUrl}/uni-api`,
  MAH_API_BASE_URL_OLD: 'https://qa-api.dstvafrica.com',
  MAH_API_BOXOFFICE: 'boxoffice-unifiedapi',
  MAH_API_BUNDLES: 'bundles-unifiedapi',
  MAH_API_BUSINESS_UNIT: 'dstv',
  MAH_API_BUSINESS_UNIT_GOTV: 'gotv',
  MAH_API_CANCEL_PACKAGE: 'cancelpackage-unifiedapi',
  MAH_API_CAPITEC_BRANCH: 'ZA_DSTVSTRMCAPITEC',
  MAH_API_CHANGE_PACKAGE: 'changepackage-unifiedapi',
  MAH_API_CHANNEL: 'webuni',
  MAH_API_CHANNEL_GOTV: 'webuni',
  MAH_API_CURRENCY: 'currency-unifiedapi',
  MAH_API_CUSTOMER_PROFILE: 'customerprofilemanagement-unifiedapi',
  MAH_API_DISCONNECT_PACKAGE: 'disconnectpackage-unifiedapi',
  MAH_API_FIX_ERROR: 'fixerror-unifiedapi',
  MAH_API_INSURANCE: 'insurance-unifiedapi',
  MAH_API_LINK: 'linkpackage-unifiedapi',
  MAH_API_LINK_DEVICE: 'linkdevice-unifiedapi',
  MAH_API_LOGIN: 'login-unifiedapi',
  MAH_API_OTP: 'genericotp-unifiedapi',
  MAH_API_PAYMENT: 'apipaymentservice',
  MAH_API_PAYMENT_CHANNEL: 'dstvafrica',
  MAH_API_PAYMENT_HISTORY: 'paymenthistory-unifiedapi',
  MAH_API_PAYMENT_PROCESSOR: 'paymentprocessor-unifiedpso',
  MAH_API_PREMIUM_STATUS: 'subscriberpremiumstatus-unifiedapi',
  MAH_API_QUOTES: 'quotemanagement-unifiedapi',
  MAH_API_RECONNECT_PACKAGE: 'reconnectpackage-unifiedapi',
  MAH_API_SUBS: 'viewsubs-unifiedapi',
  MAH_API_VAS: 'vasvalidation-unifiedapi',
  MAH_API_VERSION: 'api/v1',
  MAH_API_VERSION_2: 'api/v2',
  MAH_API_VOUCHER: 'vendorvouchermanagement-unifiedpso',
  MAH_API_XTRAVIEW: 'xtraview-unifiedapi',
  MAH_AUTH_GUID: '05bc0842-9704-4b06-886d-f2f8db747b56',
  MAH_AUTH_PAYMENT_GUID: '1e1b7e41-0ed0-4ae4-9f73-a6a8a34c186a',
  MAH_AUTH_PAYMENT_PLATFORM: 'dstvafrica',
  MAH_AUTH_PLATFORM: 'webuni',
  MAH_AUTH_URL: 'https://mahauthorizationapi.azurewebsites.net/api/Values',
  MAH: {
    Urls: {
      RecurringPayment: 'https://qa-api.dstvafrica.com/apipaymentservice/Payments/SetUpRecurring'
    }
  },
  MAH_EAZY_MOBILE_API_BASE_URL: 'https://eazy-mobile-api-uat.azurewebsites.net/api/v1',
  MINIMUM_PAY_AMOUNT: 20,
  MULTICHOICE_TERM_AND_CONDITIONS_URL: '/en-za/legal/terms-conditions',
  MYDSTV_APP_STORE_URL_APPLE: 'https://apps.apple.com/lr/app/mydstv/id6446250424',
  MYDSTV_APP_STORE_URL_GOOGLE: 'https://play.google.com/store/apps/details?id=com.multichoice.mydstv.thiane',
  MYDSTV_APP_STORE_URL_HUAWEI: 'https://appgallery.huawei.com/#/app/C108583247',
  NAMOLA_LINK: 'https://onelink.to/89qkgy',
  OBFUSCATED_CACHE: false,
  PAYMENT_IFRAME_COUNTRY_CODES: ['et', 'zw'],
  PAYMENT_PROFILE: 'Residential',
  PAY_AT_EXTERNAL_PAYMENT_LINK: 'https://payat.io/dstv',
  MOMENT_EXTERNAL_PAYMENT_LINK: 'https://dstv.dev.momentpay.io/{smartcardNumber}/{countryCode}/eng/DA/momenttest',
  PRIVACY_POLICY_URL: 'https://www.multichoice.com/privacy-cookie-notice-overview.php',
  RED_OXYGEN_GAME_CODE: '2CIJqIRaXPQPZ5IMVS3Y',
  REFRESH_TOKEN_TOLERANCE: 5,
  SHOWMAX_LINK: 'https://www.showmax.com',
  SHOW_BOUNDARY_ERROR: true,
  SKIP_DAY_OF_DEBIT_ORDER: false,
  SOURCE_FOLDER: '/content/self-service/',
  TERMS_COMPLAINTS: 'https://www.dstv.com/static/policy-documents/complaints-policy-and-procedures',
  TERMS_DEBT: 'https://www.dstv.com/static/policy-documents/debt-waiver-policy-wording',
  TERMS_DECODER: 'https://www.dstv.com/static/policy-documents/device-insurance-policy-wording',
  TERMS_DEVICE_CARE: 'https://www.dstv.com/static/policy-documents/device-care-policy-wording',
  TERMS_ETHICS: 'https://www.dstv.com/static/policy-documents/code-of-ethics-conduct-policy',
  TERMS_FUNERAL: 'https://www.dstv.com/static/policy-documents/funeral-cover-policy-wording',
  TERMS_SUBSCRIPTION: 'https://www.dstv.com/static/policy-documents/subscription-waiver-policy-wording',
  TERMS_GENERAL: 'https://www.multichoice.com/multichoice-africa-subscriber-ts-cs-overview-sa.php',
  TRANSLATED_LOCALS: ['pt-ao', 'pt-mz'],
  UMBRACO_API_URI: '/umbraco/api',
  UMBRACO_BASE_URI: '/',
  CONNECT_PROXY_URL: `${utilityServiceUrl}/connect`,
  URLS: {
    RECURRING_PAYMENT: {
      TERMS_AND_CONDITIONS: 'https://www.multichoice.com/pdf/dstv-ts-cs/tcs-for-dstv-recurring-payments.pdf',
      FAQS: 'https://www.dstv.com/en-za/help/faqs',
    },
    REWARDS: {
      TERMS_AND_CONDITIONS: 'https://www.multichoice.com/dstv-rewards.php',
    },
  },
  USE_CONNECT_AUTH: true,
  USE_CONNECT_JWT: true,
  USE_REFRESH_TOKEN: true,
  UNI_API_URI: `${utilityServiceUrl}/uni-api`,
  HYPERMEDIA_API_URI: `${utilityServiceUrl}/hypermedia`,
  UTILITY_API_URI: utilityServiceUrl,
  WHATSAPP_LINK: 'https://api.whatsapp.com/send?phone=27600603788',
  menu: localEnvironment,
  analytics: {
    enabled: true,
    defaults: {},
  },
};

export default environment;
